import React from "react";

function Map({map}){

    const [name] = map.name.split(".");

    return(
        <tr>
            <td>{name.replace("OSM", "")}</td>
            
            <td ><a href={map.url} >{map.name}</a></td>
            <td>{map.size}</td>            
            <td >{map.type}</td>
            <td >{new Date(map.date).toLocaleDateString()}</td>
        </tr>
    );

}

export default Map;